import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../../components/Layout/Layout'
import { CategoryArchive } from '../../components/archive/CategoryArcive'
import { Author } from '../../components/archive/Author'
import Seo from '../../components/Seo/Seo'
import { transformAuthorData } from '../../hooks/useAllWritersQuery'

const AuthorTemplate = ({ data }) => {
  const posts = data.allWpPost?.edges
  const author = transformAuthorData(data.wpUser)

  return (
    <Layout>
      <div className="innerContainer">
        <Author author={author} />
      </div>
      <CategoryArchive
        posts={posts}
        showBloggInAllCategory
        isBlogg
        authorName={author?.name}
      />
    </Layout>
  )
}

export const Head = ({ data }) => {
  return <Seo title={data.wpUser.name} />
}

export default AuthorTemplate

export const query = graphql`
  query ($id: String!) {
    wpUser(id: { eq: $id }) {
      id
      email
      name
      description
      roles {
        nodes {
          name
        }
      }
      avatar {
        url
      }

      userSettings {
        profileImg {
          altText
          sourceUrl
        }
        title
      }

      ...SocialLinksFragment
    }

    allWpPost(filter: { author: { node: { id: { eq: $id } } } }) {
      edges {
        node {
          ...AllWPPostsFragment
        }
      }
    }
  }
`
